import { defineStore } from 'pinia';
import { ref } from 'vue';
import type SoleConfigurationElementInterface from '@/domains/sole/typescript/interfaces/SoleConfigurationElementInterface';

export default defineStore('adminCatalog', () => {
    const catalog = ref<SoleConfigurationElementInterface[]>();

    function $reset(): void {
        console.info('reset admin catalog store');
        catalog.value = undefined;
    }

    return {
        catalog,
        $reset,
    };
});
